<div *ngIf="!dismissed" [@fadeInTop]="!dismissed" [@fadeOutTop]="!dismissed"
     class="flex items-center gap-3 px-5 py-2.5 rounded-full shadow-lg backdrop-blur-md border text-white pointer-events-auto transition-all duration-500 overflow-hidden max-w-lg"
     [ngClass]="{
         'bg-green-600/90 border-green-400/40': type === 'success' || type === 'primary' || type === 'accent' || type === 'basic',
         'bg-red-600/90 border-red-400/40':     type === 'error' || type === 'warn',
         'bg-amber-500/90 border-amber-300/40': type === 'warning',
         'bg-blue-600/90 border-blue-400/40':  type === 'info'
     }">

    <!-- Icon -->
    <mat-icon *ngIf="showIcon"
              class="icon-size-5 text-white flex-none shrink-0"
              [svgIcon]="(type === 'success' || type === 'primary' || type === 'accent' || type === 'basic')
                           ? 'heroicons_outline:check-circle'
                           : (type === 'error' || type === 'warn')
                             ? 'heroicons_outline:x-circle'
                             : type === 'warning'
                               ? 'heroicons_outline:exclamation-triangle'
                               : 'heroicons_outline:information-circle'">
    </mat-icon>

    <!-- Content -->
    <div class="flex flex-col min-w-0 flex-1">
        <div *ngIf="title" class="text-sm font-bold truncate leading-tight">
            {{ title }}
        </div>
        <div *ngIf="subTitle" class="text-[11px] font-medium opacity-80 truncate leading-none mt-0.5">
            {{ subTitle }}
        </div>
        <div *ngIf="!title && !subTitle" class="text-sm font-bold leading-tight">
            <ng-content></ng-content>
        </div>
    </div>

    <!-- Dismiss button -->
    <button *ngIf="dismissible"
            class="shrink-0 w-5 h-5 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 transition-colors cursor-pointer border-0 p-0"
            (click)="dismiss()">
        <mat-icon class="icon-size-3.5 text-white" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
    </button>

</div>